import LOADER from '@ott/utility-loader';

import * as T from '../types';

const initialState = {
  status: LOADER.initial(),
  authId: null,
  iframeUrl: null,
  isOld3DS: true,
  serverIframeUrl: null,
  threeDSMethodData: null,
};

function index(state = initialState, action = {}) {
  switch (action.type) {
    case T.GET_PRE_AUTH: {
      return {
        ...state,
        status: LOADER.begin(),
      };
    }

    case T.GET_PRE_AUTH_SUCCESS: {
      return {
        ...state,
        status: LOADER.success(),
        ...action.result,
      };
    }

    case T.GET_PRE_AUTH_FAIL: {
      return {
        ...state,
        status: LOADER.error(action.error),
        authId: action.error.authId || null,
      };
    }

    case T.RESET: {
      return initialState;
    }

    default:
      return state;
  }
}

export default index;
